import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import {
  Component,
  ViewChild,
  QueryList,
  Input,
  ContentChildren,
} from '@angular/core';
import { AndromedaMenuOptionComponent } from '../andromeda-menu-option/andromeda-menu-option.component';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { UiStateService } from '../../services/ui-state.service';

/**
 * Andromeda Menu Component
 *
 * Composant d'affichage d'un menu pour le composant Select.
 */
@Component({
  selector: 'lib-andromeda-menu',
  templateUrl: './andromeda-menu.component.html',
  styleUrls: ['./andromeda-menu.component.scss'],
  imports: [CommonModule, OverlayModule],
})
export class AndromedaMenuComponent {
  @Input() closeOnSelection = true;
  @Input() closeOnClickOutside = true;
  @Input() disabled = false;

  @ViewChild('trigger')
  trigger: { elementRef: { nativeElement: HTMLElement } };

  @ViewChild('menuTrigger')
  menuTrigger: HTMLElement;

  @ViewChild(CdkConnectedOverlay, { static: false })
  overlay: CdkConnectedOverlay;

  @ContentChildren(AndromedaMenuOptionComponent)
  menuOptions: QueryList<AndromedaMenuOptionComponent>;

  isOpen = false;

  // eslint-disable-next-line no-unused-vars
  constructor(private uiStateService: UiStateService) {
    // This is intentional
  }

  /**
   * Ouvre le menu.
   *
   * @param event
   */
  onClickOnMenuTrigger(event): void {
    this.isOpen = this.disabled ? false : !this.isOpen;
    event.stopPropagation();
  }

  /**
   * Ferme le menu si l'utilisateur clique à l'extérieur.
   *
   * @param event
   */
  clickOnBackdrop(event): void {
    this.uiStateService.clearMenuIconsOnly();

    this.isOpen = !this.closeOnClickOutside;

    event.stopPropagation();
  }

  /**
   * Ferme le menu après la sélection d'une option.
   *
   * @param event
   * @param stopPropagation
   */
  optionHasBeenClicked(event, stopPropagation?): void {
    this.uiStateService.clearMenuIconsOnly();
    this.isOpen = !this.closeOnSelection;
    if (stopPropagation) {
      event.stopPropagation();
    }
  }
}
